import { Injectable, signal } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { PaymentCatalogService } from './payment-catalog.service';
import {
  PaymentGatewayTypeOption,
  PaymentMethodOption,
} from '@shared/models/payment-catalog.model';

@Injectable({ providedIn: 'root' })
export class PaymentCatalogStore {
  readonly paymentMethods = signal<PaymentMethodOption[]>([]);
  readonly paymentGatewayTypes = signal<PaymentGatewayTypeOption[]>([]);

  private methodsLoaded = false;
  private loadedGatewayTenant: string | null = null;

  constructor(private service: PaymentCatalogService) {}

  loadPaymentMethods(): Observable<PaymentMethodOption[]> {
    if (this.methodsLoaded) return of(this.paymentMethods());

    return this.service.getPaymentMethods().pipe(
      tap((methods) => {
        this.paymentMethods.set(methods);
        this.methodsLoaded = true;
      }),
    );
  }

  loadPaymentGatewayTypes(tenantId: string): Observable<PaymentGatewayTypeOption[]> {
    if (this.loadedGatewayTenant === tenantId) return of(this.paymentGatewayTypes());

    return this.service.getPaymentGatewayTypes(tenantId).pipe(
      tap((types) => {
        this.paymentGatewayTypes.set(types);
        this.loadedGatewayTenant = tenantId;
      }),
    );
  }
}
